<script>
    import main from './App.svelte';
    import android from './Appstore.svelte';
    var paths = window.location.pathname.substr(1).split('/');
    var views = { main, android, 'appstore' : android };
</script>

<svelte:component this={views[paths.length>0 && paths[0]!='' ? paths[0] : 'main']}/>
